export const ZOOM_MODE_YEAR = "zoomLevelYear";
export const ZOOM_MODE_MONTH = "zoomLevelMonth";
export const ZOOM_MODE_WEEK = "zoomLevelWeek";
export const ZOOM_MODE_DAY = "zoomLevelDay";

export const HEADER_UNIT_MAIN_YEAR = "yearMain";
export const HEADER_UNIT_MAIN_MONTH = "monthMain";
export const HEADER_UNIT_MAIN_WEEK = "weekMain";
export const HEADER_UNIT_MAIN_DAY = "dayMain";
export const HEADER_UNIT_SUB_MONTH = "monthSub";
export const HEADER_UNIT_SUB_DAY = "daySub";
export const HEADER_UNIT_SUB_HOUR = "hourSub";

export const TASK_HEIGHT_LOOSE = 28;
export const TASK_HEIGHT_COMPACT = 20;

export const VIEWPORT_TITLE_HEIGHT = 48;
export const DRAG_DELTA_DEADZONE = 10;

export const EXPAND_COLUMN_WIDTH = 30;
export const DEFAULT_SIDEBAR_WIDTH = 500;

export const TIMELINE_MIN_HEIGHT = 200;

export const SETTINGS_HEIGHT = 80;

export const RESIZER_THICKNESS = 8;

export const TASK_MIN_WIDTH = 26;

export const DRAG_LINK = "drag_link";
export const DRAG_MOVE = "drag_move";
export const DRAG_RESIZE_START = "drag_resize_start";
export const DRAG_RESIZE_END = "drag_resize_end";

// Colours:

export const EDIT_FORM_ROW_BORDER = "#78899a";

export const GRAPHVIEWPORT_BACKGROUND_ACTIVE = "#ffffff";
export const GRAPHVIEWPORT_BACKGROUND_OUTSIDE = "#525252";

export const EDITBOX_BORDER = "#6A9844";

export const CALENDAR_SELECTION = EDITBOX_BORDER;

export const SIDELIST_TITLE_BACKGROUND = "#525252";
export const SIDELIST_COLUMN_BACKGROUND = "#eaeaea";
export const SIDELIST_COLUMN_BACKGROUND_HOVER = "#bbb";
export const SIDELIST_COLUMN_BACKGROUND_ACTIVE = "#999";
export const SIDELIST_ROW_BORDER = "#D7DADD";

export const SIDE_LIST_BACKGROUND = "#fff";
export const HEADER_BACKGROUND = "#eaeaea";
export const HEADER_BACKGROUND_WEEKEND = "#D8D8D8";
export const HEADER_BACKGROUND_TODAY = "#FFF";
export const SELECT_GREEN = "#8ECD5B";

export const BORDER_COLOR = "#7D7C7D";

export const SETTINGS_BACKGROUND_COLOR = "#D7DADD";
export const SETTINGS_TEXT_COLOR = "#3A4855";
export const VERTICAL_SEPARATOR_COLOR = "#3A4855";

export const BUTTON_BACKGROUND_COLOR = "#3A4855";
export const BUTTON_HOVER_SHADOW_COLOR = "#ACDA86";
export const BUTTON_DISABLED_COLOR = "#BBBBBB";
export const BUTTON_ACTIVE_COLOR = EDITBOX_BORDER;
export const BUTTON_BORDER_COLOR = "#3A4855";
export const BUTTON_DEFAULT_WIDTH = 136;
export const BUTTON_DEFAULT_HEGITH = 42;

export const KEYCODE_ENTER = 13;

export const ITEM_DEFAULT_COLOR = "#000000";

export const SCROLLBAR_WIDTH = 17;
export const SCROLLBAR_BORDER = 4;
export const SCROLLBAR_BACKGROUND = "#eaeaea";
export const SCROLLBAR_COLOR = "#a8a8a8";
export const SCROLLBAR_HOVERCOLOR = "#7D7C7D";

export interface IZoomMode {
  labelText: string;
  preliminaryHourWidth: number;
  headerUnits: string[];
  extraContextDays: number;
}

export interface IZoomModeInfo {
  [ZOOM_MODE_YEAR]: IZoomMode;
  [ZOOM_MODE_MONTH]: IZoomMode;
  [ZOOM_MODE_WEEK]: IZoomMode;
  [ZOOM_MODE_DAY]: IZoomMode;
}

export const zoomModeInfo: IZoomModeInfo = {
  [ZOOM_MODE_YEAR]: {
    labelText: "year",
    preliminaryHourWidth: 2 / 24,
    headerUnits: [HEADER_UNIT_MAIN_YEAR, HEADER_UNIT_SUB_MONTH],
    extraContextDays: 0, //120,
  },
  [ZOOM_MODE_MONTH]: {
    labelText: "month",
    preliminaryHourWidth: TASK_MIN_WIDTH / 24,
    headerUnits: [HEADER_UNIT_MAIN_MONTH, HEADER_UNIT_SUB_DAY],
    extraContextDays: 0, //20,
  },
  [ZOOM_MODE_WEEK]: {
    labelText: "week",
    preliminaryHourWidth: 2,
    headerUnits: [HEADER_UNIT_MAIN_WEEK, HEADER_UNIT_SUB_DAY],
    extraContextDays: 0, //10,
  },
  [ZOOM_MODE_DAY]: {
    labelText: "day",
    preliminaryHourWidth: 24,
    headerUnits: [HEADER_UNIT_MAIN_DAY, HEADER_UNIT_SUB_HOUR],
    extraContextDays: 0, //2,
  },
};

export interface IHeaderUnit {
  justify: boolean;
  format: string;
}

export interface IHeaderUnitInfo {
  [HEADER_UNIT_MAIN_YEAR]: IHeaderUnit;
  [HEADER_UNIT_MAIN_MONTH]: IHeaderUnit;
  [HEADER_UNIT_MAIN_WEEK]: IHeaderUnit;
  [HEADER_UNIT_MAIN_DAY]: IHeaderUnit;
  [HEADER_UNIT_SUB_MONTH]: IHeaderUnit;
  [HEADER_UNIT_SUB_DAY]: IHeaderUnit;
  [HEADER_UNIT_SUB_HOUR]: IHeaderUnit;
}

//Format translated in Headers.js
//https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
//https://github.com/date-fns/date-fns/blob/master/src/_lib/format/formatters/index.ts
export const headerUnitInfo: IHeaderUnitInfo = {
  [HEADER_UNIT_MAIN_YEAR]: {
    justify: false,
    format: "headerunitformat.yearmain",
  },
  [HEADER_UNIT_MAIN_MONTH]: {
    justify: false,
    format: "headerunitformat.monthmain",
  },
  [HEADER_UNIT_MAIN_WEEK]: {
    justify: false,
    format: "headerunitformat.weekmain",
  },
  [HEADER_UNIT_MAIN_DAY]: {
    justify: false,
    format: "headerunitformat.daymain",
  },
  [HEADER_UNIT_SUB_MONTH]: {
    justify: false,
    format: "headerunitformat.monthsub",
  },
  [HEADER_UNIT_SUB_DAY]: {
    justify: true,
    format: "headerunitformat.daysub",
  },
  [HEADER_UNIT_SUB_HOUR]: {
    justify: true,
    format: "headerunitformat.hoursub",
  },
};
